import { render, staticRenderFns } from "./AccountSettingsCard.vue?vue&type=template&id=1f54b29b&scoped=true&"
import script from "./AccountSettingsCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AccountSettingsCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AccountSettingsCard.vue?vue&type=style&index=0&id=1f54b29b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54b29b",
  null
  
)

export default component.exports